export const getFormTemplatePrompt = {
    prompt: `
    {
  "changesPublished": false,
  "completionButtonLabel": "Complete Form",
  "isAnonymous": false,
  "isInfinitelyRespondable": false,
  "name": "Example Survey",
  "isPasscodeRequired": false,
  "pages": [
    {
      "questions": [
        {
          "options": null,
          "question": "Give short text answer",
          "type": "short text"
        },
        {
          "options": null,
          "question": "Give Long text answer",
          "type": "long text"
        },
      ],
      "welcomeText": {
        "ops": [
          {
            "insert": "Example Survey welcome text for first page\\n"
          }
        ]
      }
    },
    {
      "questions": [
        {
          "options": [
            {
              "id": "Xpb2CqZbrbzDnZErWyNHu",
              "label": "Green"
            },
            {
              "id": "-W9VF84ndY45PlhqjQ6U5",
              "label": "Red"
            },
            {
              "id": "nC1zLvwoSXbxzsfgSHT5P",
              "label": "Blue"
            }
          ],
          "question": "Select from Multiple Choices",
          "type": "select one"
        },
        {
          "options": [
            {
              "id": "LTiXkRNIJJXyBOsUGfXO4",
              "label": "olives"
            },
            {
              "id": "HImq6kmp_YK-AoS2zPdav",
              "label": "onion"
            },
            {
              "id": "zc8VmGxycUubU34WmvfVK",
              "label": "pepperoni"
            },
            {
              "id": "w4ckBKznKrx_4YAColuJw",
              "label": "anchovy"
            }
          ],
          "question": "Checkbox Question",
          "type": "select many"
        }
      ],
      "welcomeText": {
        "ops": [
          {
            "insert": "Here is some example Survey welcome text for second page\\n"
          }
        ]
      }
    }
  ],
  "welcomePageRichText": {
    "ops": [
      {
        "insert": "Example Survey welcome text for welcome page\\n"
      }
    ]
  }
}

Using the above JSON as a pattern for a form template, please create the following form template:
  `,
};
